import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useAddTimedPlusBidSuggestionsToBidCanvasExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.AddTimedPlusBidSuggestionsToBidCanvas,
        AmplitudeVariants.AddTimedPlusBidSuggestionsToBidCanvas.Treatment
    );
